import React, { use, useEffect, useState } from "react";
import style from "./style.module.css";

const DetailPersonalTrainer=(props)=>{
const url = props.url;
const[dataPesertaKiri,setDataPesertaKiri]=useState([]);
const[dataDetailPesertaKanan,setDataDetailPesertaKanan]=useState([]);

// function ambil data detail peserta kanan
const GetDetailKehadiranPeserta=(namaPeserta)=>{
    fetch(url + "/?op=getDetailKehadiranPeserta", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "nama_trainer=" + props.namaTrainer+
      "&nama_peserta=" +namaPeserta
    })
    .then((response) => response.json())
    .then((json)=>{
        if(json!==null){
setDataDetailPesertaKanan(json);
        }else{
            setDataDetailPesertaKanan([]);
        }
    })
}
    // function ambil list data user aktif trainer
    const GetListDetailPesertaKiri=()=>{
fetch(url + "/?op=getListDetailPesertaKiri", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "nama_trainer=" + props.namaTrainer 
    })
    .then((response) => response.json())
    .then((json)=>{
        if(json!==null){
setDataPesertaKiri(json);
        }else{
setDataPesertaKiri([]);
        }
    })
}
//use effect
useEffect(()=>{
GetListDetailPesertaKiri();
},[props.namaTrainer])
 
return(
    <div className={style.containerAll}>
<div className={style.containerKiri}>
    <div className={style.judulContainerKiri}>
Detail Nama Peserta PT
    </div>
    <div className={style.divTabelKiri}>
<table className={style.tabelKiri}>
<thead>
<tr>
    <th>
        Nama
    </th>
    <th>
        Status
    </th>
    <th>
        Paket
    </th>
    <th>
        Berjalan
    </th>
    <th>
        Sisa
    </th>
    <th>
        Absensi
    </th>
</tr>
</thead>
<tbody>
{dataPesertaKiri.map((item,index)=>(
    <tr key={index}>
        <td style={{cursor:"pointer",color:props.namaPeserta === item.nama_peserta?"blue":""}} onClick={()=>{
GetDetailKehadiranPeserta(item.nama_peserta);
props.UbahNamaPeserta(item.nama_peserta)
        }}>
{item.nama_peserta}
        </td>
         <td>
{item.status_pertemuan}
        </td>
         <td>
{item.paket_pertemuan}
        </td>
         <td>
{item.berjalan_pertemuan}
        </td>
         <td>
{item.sisa_pertemuan}
        </td>
         <td>
<button onClick={()=>{
    props.KlikHadir(item.nama_peserta,props.rfidTrainer,item.nomor_hp,item.nama_trainer,item.sisa_pertemuan,item.berjalan_pertemuan,item.timestamp);
}} style={{cursor:"pointer"}}>
    Hadir
</button>
        </td>
    </tr>
))}
</tbody>
</table>
    </div>
    </div>
   
         <div style={{display:props.namaPeserta!==""&&props.namaTrainer!==""?"block":"none"}} className={style.containerKanan}>
        <div className={style.judulContainerKanan}>
Kehadiran Peserta Training
        </div>
        <div className={style.divTabelKiri}>
<table className={style.tabelKiri}>
<thead>
<tr>
    <th>
        Nama
    </th>
     <th>
        Kehadiran
    </th>
</tr>
</thead>
<tbody>
{dataDetailPesertaKanan.map((item,index)=>(
    <tr key={index}>
<td>
    {item.nama_peserta}
</td>
<td>
    {item.timestamp}
</td>
    </tr>
))}
</tbody>
</table>
        </div>
    </div>

   
    </div>
)
}

export default DetailPersonalTrainer;